import React from "react";

// Ajoute une indication visuelle de si un champ est correct ou non
export function validateField(
    fieldValue: string | undefined,
    fieldType: "phone" | "email"): JSX.Element | undefined
    {
        if (!fieldValue || fieldValue.match(regexMap[fieldType])) {
            return undefined
        }

  return <div style={{color: "var(--main-red)"}}>Valeur invalide</div>
}

const regexMap: Record<string, RegExp> = {
  email: /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/,
  phone: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
};